import { useEffect } from 'react';

const getRobotsContent = () => {
  const hostname = window.location.hostname;
  
  if (hostname.includes('alc-dev.chosun.com')) {
    return 'User-agent: *\nDisallow: /';
  }
  
  return 'User-agent: *\nAllow: /';
};

const RobotsRoute = () => {
  useEffect(() => {
    const robotsContent = getRobotsContent();
    
    const blob = new Blob([robotsContent], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = 'robots.txt';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, []);

  return null;
};

export default RobotsRoute;
